module.exports = __webpack_public_path__ + "static/media/volume-bonus-header-image.b5e2477f.png";